export const HEALTH = {
    GET_HEALTH: "/health",
    GET_ADMIN_STATS: "/admin/stats",
    GET_ADMIN_UPTIME: "/admin/uptime",
    GET_DELIVERY_LOGS: "/admin/delivery-logs",
    GET_INTEGRATIONS_HEALTH: "/admin/integrations-health",
    GET_CRON_HEALTH: "/admin/cron-health",
};

export const AUTH = {
    POST_SIGNUP: "/user/create",
    POST_LOGIN: "/user/login",
    ONCE_AUTHENTICATE: "/user/oncetoken"
};

export const SUBSCRIPTION = {
    GET_PRICE: "/plan",
    PRICE_EDIT: "/plan/update-price",
    STRIPE_CHANGE_RECORDS: "/plan/stripe-change-records",
    PLAN_HISTORY: "/plan-history"
};

export const USER_MANAGEMENT = {
    GET_ALL_USER: "/user/getAll",
    GET_SINGLE_USER: "/user/details",
    UPDATE_USER: "/user/update/",
    DELETE_USER: "/user",
    BULK_DELETE_USERS: "/user/bulk",
    PLAN_OVERRIDE: "/user",
    TRIAL_EXTEND: "/user",
    PLAN_CHANGES: "/user/plan-changes",
    UPLOAD_PROFILE_PICTURE: "/user/upload-profile-pic",
    VERIFY_EMAIL: "/user/verify-email",
    GET_PROFILE_PICTURE: "/user/profile-pic/",
    SUBSCRIPTION_PAYMENT:"/payment/create-checkout-session",
    CHECKOUT_SESSION_SUMMARY: "/payment/checkout-session",
    SYNC_CHECKOUT_SESSION: "/payment/sync-checkout-session",
    CUSTOMER_PORTAL: "/payment/customer-portal",
    SUBSCRIPTION_UPDATE: "/payment/subscription/update",
    SUBSCRIPTION_ADDONS: "/payment/subscription/addons",
    SUBSCRIPTION_CANCEL: "/payment/subscription/cancel",
    SUBSCRIPTION_REACTIVATE: "/payment/subscription/reactivate",
    RESET_PASSWORD_EMAIL: "/user/reset-password-email",
    RESET_PASSWORD: "/user/reset-password",
    PUSH_NOTIFICATION: "/user/push-notification",
};
export const PLANS = {
    BASIC: 'Basic',
    TRIP: 'Trips',
    ZONE: 'Zones',
    REPORT: 'Reports',
    ALL_IN_ONE: 'All-in-One Bundle'
}
export const DEVICE = {
    TOKEN_DEVICE :"https://api.gpsiot.net/token",
    GET_CURRENT_DEVICE_STATUS :"/device",
    GET_DEVICE_TYPE : "https://api.gpsiot.net/api/Asset/GetDeviceTypes",
    CREATE_DEVICE : "/device",
    GET_DEVICE_STATUS :"/device-status",
    GET_DEVICE_LOCATIONS :"/device/locations", 
    GET_SINGLE_SIM_DETAIL: "/device/singleSimeDetail",
    SEND_SMS: "/device/sendSms",
    GET_DEVICE_TRIP: "/trip/",
    CREATE_TRIP: "/trip/create",
    GET_TRIP: "/trip",
    RESUME_TRIP: "/trip/resume",
    PAUSE_TRIP: "/trip/pause",
    END_TRIP: "/trip/stop",
    UPDATE_MODE: '/device/update-mode',
    GET_DEVICE_LOCATIONS_v2 :"/device/locations/v2", 
    GET_ZONE_DEVICE_DETAILS: "/zone/details/",
}

export const ZONES = {
    GET_ALL_ZONES: "/zone",
    DELETE_ZONE: "/zone",
    CREATE_ZONE: "/zone",
    GET_ALL_ZONES_DEVICES: "/zone/devices-location",
    GET_ZONE_ACTIVITY: "/zone/activity",
}

export const ZONE_TIMER = {
    CREATE_TRIP: "/zone-timer/create",
    GET_TRIP: "/zone-timer",
    RESUME_TRIP: "/zone-timer/resume",
    PAUSE_TRIP: "/zone-timer/pause",
    END_TRIP: "/zone-timer/stop",
}

export const TIME_LOGS = {
    CLOCK_IN: "/time-logs/clock-in",
    CLOCK_PAUSE: "/time-logs/clock-pause",
    CLOCK_RESUME: "/time-logs/clock-resume",
    CLOCK_OUT: "/time-logs/clock-out",
    LIST: "/time-logs",
    STATUS: "/time-logs/status",
    USER_LOGS: (userId) => `/time-logs/user/${userId}`,
    REPORT: "/time-logs/report",
    PAGE: "/main/time-tracking",
};

export const ZONESGroup = {
    GET_ALL_ZONES: "/zone-groups",
    DELETE_ZONE: "/zone-groups",
    CREATE_ZONE: "/zone-groups/",
    GET_ALL_ZONES_DEVICES: "/zone-groups/devices-location",
}

export const SMS_COMMANDS = {
    BATTRY: 'BAT',
    UNLOCK: 'RELEASE',
    LOCK: 'CLAMP',
    BEEP: 'BEEP',
    RECOVER_MODE_3:"RECOVER_MODE_3",
    RECOVER_MODE_30:"RECOVER_MODE_30",
}

export const MESSAGE = {
    DEVICE_CREATED: 'Device created successfully',
    SOMETHING_WRONG: 'Something went wrong',
    UNEXPECTED_ERR: 'An unexpected error occurred',
    SIM_VALIDATION: 'Please check SIM Card Number',
    IMEI_VALIDATION: 'Please check IMEI Number'
}

export const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

export const REPORT = {
    POST_REPORT: '/reports/create',
    GET_REPORT: '/reports/get-report',
    UPDATE_REPORT: '/reports/update',
    GET_ALL_REPORTS: '/reports/get-reports',
    Delete_REPORTS : '/reports'
}
